import { z } from 'zod';

export const contactSchema = z.object({
    name: z
        .string()
        .min(2, 'Name must be at least 2 characters')
        .max(100, 'Name is too long'),
    email: z
        .string()
        .email('Invalid email address'),
    phone: z
        .string()
        .regex(/^\+?[\d\s\-().]{7,20}$/, 'Invalid phone number')
        .optional()
        .or(z.literal('')),
    company: z
        .string()
        .max(100, 'Company name is too long')
        .optional()
        .or(z.literal('')),
    subject: z
        .string()
        .min(3, 'Subject must be at least 3 characters')
        .max(200, 'Subject is too long'),
    message: z
        .string()
        .min(10, 'Message must be at least 10 characters')
        .max(5000, 'Message is too long'),
    type: z.enum(['project', 'job', 'collaboration', 'other']),
    budget: z
        .string()
        .max(100, 'Budget value is too long')
        .optional()
        .or(z.literal('')),
    projectType: z
        .string()
        .max(200, 'Project type is too long')
        .optional()
        .or(z.literal('')),
});

export type ContactFormData = z.infer<typeof contactSchema>;

export type ContactFormErrors = Partial<Record<keyof ContactFormData, string>>;

export function validateContact(
    data: unknown
): { success: true; data: ContactFormData } | { success: false; errors: ContactFormErrors } {
    const result = contactSchema.safeParse(data);
    if (result.success) return { success: true, data: result.data };

    const errors: ContactFormErrors = {};
    for (const issue of result.error.issues) {
        const field = issue.path[0] as keyof ContactFormData;
        if (field && !errors[field]) {
            errors[field] = issue.message;
        }
    }
    return { success: false, errors };
}
